import {
  getMaxDiscountAmount,
  getTotalTreatmentDiscounts,
  getTotalPayorDiscounts,
} from 'Data/case-closer.js'

export function getTreatmentDiscounts(discounts) {
  return getTotalTreatmentDiscounts({ discounts })
}

export function getPayorDiscounts(discounts) {
  return getTotalPayorDiscounts({ discounts })
}

export function getMaxDiscount(max_discount, payment_plan) {
  return getMaxDiscountAmount({
    max_discount,
    payor_share: payment_plan.payors[0].share.amount,
    treatment_fee: payment_plan.treatment_fee,
  })
}
